import { useCallback, useMemo } from 'react';
// import { useSignals } from '@preact/signals-react/runtime';
import { useEffectOnce } from 'react-use';
import jsonData from '../signals/jsonData';
import configData from '../signals/configData';
import useRecord from './useRecord';

const useData = () => {
	// useSignals();

	const { exhibitorInfo } = jsonData.value;
	const { userAPI } = configData.value;
	const { makeRecord } = useRecord();

	const visitorParam = useMemo(() => {
		const params = new URLSearchParams(window.location.search);
		const visitor = params.get('visitor');
		return visitor;
	}, []);

	const token = useMemo(() => {
		const params = new URLSearchParams(window.location.search);
		const token = params.get('vtoken');
		return token;
	}, []);

	useEffectOnce(() => {
		if (visitorParam && token && userAPI && !window.favFetched) {
			window.favFetched = true;
			fetch(`${userAPI}?token=${token}&visitor_id=${visitorParam}`)
				.then(response => response.json())
				.then(data => {
					if (data.message) alert(data.message);
					const serverFavouriteExhibitors = data.data.map(exhibitor => exhibitor['company_booth_number']);
					const updatedExhibitorInfo = exhibitorInfo.map(exhibitor => {
						if (serverFavouriteExhibitors.includes(exhibitor['攤位號碼'])) {
							return {
								...exhibitor,
								favourite: true,
							};
						}
						return {
							...exhibitor,
							favourite: false,
						};
					});

					const localData = JSON.parse(localStorage.getItem('data'));
					if (localData) {
						localData.favouriteExhibitors = serverFavouriteExhibitors;
						localStorage.setItem('data', JSON.stringify(localData));
					} else {
						localStorage.setItem('data', JSON.stringify({
							favouriteExhibitors: serverFavouriteExhibitors,
						}));
					}

					jsonData.value = {
						...jsonData.value,
						exhibitorInfo: updatedExhibitorInfo,
					};
				})
				.catch(error => console.error(error));
		}
	});


	const updateLocalFavourites = useCallback((boothNumber) => {
		const updatedExhibitorInfo = exhibitorInfo.map(exhibitor => {
			if (exhibitor['攤位號碼'] === boothNumber) {
				const updatedExhibitor = {
					...exhibitor,
					favourite: !exhibitor.favourite,
				};

				const localData = JSON.parse(localStorage.getItem('data'));

				if (localData) {
					if (updatedExhibitor.favourite) {
						localData.favouriteExhibitors.push(boothNumber);
					} else {
						localData.favouriteExhibitors = localData.favouriteExhibitors.filter(favouriteBoothNumber => favouriteBoothNumber !== boothNumber);
					}
					localStorage.setItem('data', JSON.stringify(localData));
				} else {
					localStorage.setItem('data', JSON.stringify({
						favouriteExhibitors: [boothNumber],
					}));
				}

				if (updatedExhibitor.favourite) makeRecord({ Action: 'F', Booth: boothNumber });

				return updatedExhibitor;
			}

			return exhibitor;
		});

		jsonData.value = {
			...jsonData.value,
			exhibitorInfo: updatedExhibitorInfo,
		};
	}, [exhibitorInfo, makeRecord]);


	const toggleFavourite = useCallback((boothNumber) => {
		if (visitorParam && token && userAPI && boothNumber) {
			exhibitorInfo.map(exhibitor => {
				if (exhibitor['攤位號碼'] === boothNumber) {
					const updatedExhibitor = {
						...exhibitor,
						favourite: !exhibitor.favourite,
					};

					if (updatedExhibitor.favourite) {
						fetch(`${userAPI}?token=${token}&visitor_id=${visitorParam}&company_booth_number=${boothNumber}`, {
							method: 'POST',
						})
							.then(response => response.json())
							.then(data => {
								// if (data.message) alert(data.message);
							})
							.catch(error => console.error(error));
					}

					if (!updatedExhibitor.favourite) {
						fetch(`${userAPI}?token=${token}&visitor_id=${visitorParam}&company_booth_number=${boothNumber}`, {
							method: 'DELETE',
						})
							.then(response => response.json())
							.then(data => {
								// if (data.message) alert(data.message);
							})
							.catch(error => console.error(error));
					}

					return updatedExhibitor;
				}

				return exhibitor;
			});
		}

		updateLocalFavourites(boothNumber);
	}, [exhibitorInfo, token, updateLocalFavourites, userAPI, visitorParam]);

	return {
		toggleFavourite,
	};
}
export default useData;